import React from 'react';
import { COLORS } from '@constants';
import { Icon } from '@ui';
import dayjs from 'dayjs';

export const getColumns = (onDownload) => [
    {
        title: <span data-e2e='invoices_statements-period_column'>Period</span>,
        dataIndex: 'period',
        key: 'period',
        width: '40%',
        render: (_, record) => {
            const start = dayjs(record?.monthStart).utc();
            const end = dayjs(record?.monthEnd).utc();

            const formatted = `${start.format('MMMM D')} - ${end.format('MMMM D, YYYY')}`;

            return <span data-e2e={`invoices_statements-${record.id}-period_value`}>{formatted}</span>;
        }
    },
    {
        title: <span data-e2e='invoices_statements-number_column'>Statement number</span>,
        dataIndex: 'sequenceNumber',
        key: 'sequenceNumber',
        align: 'right',
        render: (value, record) => {
            return <span data-e2e={`invoices_statements-${record.id}-number_value`}>{value}</span>;
        }
    },
    {
        title: <span data-e2e='invoices_statements-pdf-download_column'>PDF download</span>,
        dataIndex: 'pdfDownload',
        key: 'pdfDownload',
        align: 'right',
        render: (_, record) => (
            <Icon
                data-e2e={`invoices_statements-pdf-${record.id}-download_btn`}
                onClick={() =>
                    onDownload({
                        created_at_min: record.monthStart,
                        created_at_max: record.monthEnd
                    })
                }
                cursor='pointer'
                size='24px'
                color={COLORS.$gray60Black}
                component={() => <Icon.DownloadIcon />}
            />
        )
    }
];
